import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Gtp } from 'src/app/shared/gtp';
import { DistanciaEntreMovilesService } from 'src/app/services/flota/distancia-entre-moviles-service/distancia-entre-moviles.service';

@Component({
  selector: 'app-filter-distancia-entre-moviles',
  templateUrl: './filter-distancia-entre-moviles.component.html',
  styleUrls: ['./filter-distancia-entre-moviles.component.scss']
})
export class FilterDistanciaEntreMovilesComponent implements OnInit {

  @ViewChild('filtro_desde', { static: true }) filtro_desde; 
  @ViewChild('filtro_hasta', { static: true }) filtro_hasta; 

  public loading: boolean = false;  
  public alertMsg: string = '';  
  public showAlertMsg: boolean = false;    
  //Datos de Lenguaje del DateTime Picker
  fechalang:any; 
  //Filtros de Búsqueda
  public filter = {
    desde : null,
    hasta : null
  }

  constructor(
    private router: Router,
    private gtp: Gtp,
    private callApi: DistanciaEntreMovilesService
  ) {     
    
  }

  ngOnInit() {    
    this.fechalang = this.gtp.fechalang;
    let fecha = this.gtp.DiaEntero();
    this.filter.desde = fecha.desde;
    this.filter.hasta = fecha.hasta;    
  }

  /**
   * Realiza la consulta del filtro
   */
  doFilterForm(){    
    this.loading = true;
    this.showAlertMsg = false;
    let filter = this.filter;    
    if(filter.hasta<filter.desde){      
      this.showAlertMsg = true;
      this.alertMsg = 'Favor Verificar las fechas';
    }
    if(this.showAlertMsg){
      setTimeout(function(){ this.showAlertMsg = false; }, 2000);
      this.loading = false;
      return false;
    }
    this.goToRoute(filter);
    this.loading = false;
  }

  /**
   * Envía a la ruta de los resultados del filtrado
   * @example
   * goToRoute({ desde: '01-01-2019 00:00:00', hasta: '01-01-2019 00:00:00', velocidad: 10 })
   */
  goToRoute(filter){
    let sendFilter = JSON.parse(JSON.stringify(filter));
    sendFilter.desde = this.gtp.formatDate(sendFilter.desde);
    sendFilter.hasta = this.gtp.formatDate(sendFilter.hasta);
    this.router.navigate(['/flota/distancia-entre-moviles']).then(()=>{
      this.callApi.setFiltroForm(sendFilter);
    });    
  }

  /**
   * Define la fecha / hora actual para un campo de filtrado
   * @param filtro Define a que campo de filtrado se le quiere agregar el valor ( desde o hasta )
   * @example 
   * fechaHoraActual('desde');
   */
  fechaHoraActual(filtro){
    let fecha = this.gtp.DiaHoraActual();
    if(filtro == 'desde'){ 
      this.filter.desde = fecha; 
      this.closePicker('desde');
    }
    if(filtro == 'hasta'){ 
      this.filter.hasta = fecha; 
      this.closePicker('hasta');
    }
  }

  /**
   * Cierra un dateTimePicker
   * @param filtro Define cual dateTimePicker cerrar
   * @example
   * closePicker('desde');
   */
  closePicker(filtro){
    if(filtro == 'desde'){ this.filtro_desde.hideOverlay(); }
    if(filtro == 'hasta'){ this.filtro_hasta.hideOverlay(); }
  }

  ngOnDestroy() {
    this.gtp.setMainOutlet(false);
  }

}
